var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.modalId,
        "aria-labelledby": _vm.modalId,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content py-0 px-1 px-md-2" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body px-2 py-2" },
            [
              _vm._l(
                _vm.priceDetails.offersPriceDetails,
                function (offerPriceDetails, index) {
                  return _c("PriceDetailsContent", {
                    key: _vm.modalId + "-" + index,
                    staticClass: "my-1",
                    attrs: {
                      id: _vm.modalId + "-" + index,
                      index: index,
                      "offer-price-details": offerPriceDetails,
                    },
                  })
                }
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c("hr", {
                  staticClass: "separator separator--gray4 my-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-start",
                  },
                  [
                    _c("p", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: _vm.priceDetails.finalPriceLabel,
                          expression: "priceDetails.finalPriceLabel",
                        },
                      ],
                      staticClass: "lead fw-bold mb-0",
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-end" },
                      [
                        _c("Price", {
                          attrs: {
                            price: _vm.priceDetails.finalPrice,
                            "initial-price":
                              _vm.priceDetails.finalPermanentPrice,
                            duration: _vm.priceDetails.finalPriceDuration,
                            "is-cents-format": true,
                            "show-by-month": true,
                            "show-promo-duration":
                              _vm.finalDiscountType === "PROMO_DURATION",
                            "show-end-of-promotion-price":
                              _vm.finalDiscountType === "END_OF_PROMO",
                            "cashback-type": _vm.cashbackType,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close pt-2 pt-md-0",
          staticStyle: { display: "block !important" },
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-close ob1-link-arrow back",
          staticStyle: { display: "none !important" },
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                    Fermer\n                ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer py-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                    Fermer\n                ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }